import { render, staticRenderFns } from "./exchange-item.vue?vue&type=template&id=59625850&scoped=true"
import script from "./exchange-item.vue?vue&type=script&lang=js"
export * from "./exchange-item.vue?vue&type=script&lang=js"
import style0 from "./exchange-item.vue?vue&type=style&index=0&id=59625850&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59625850",
  null
  
)

export default component.exports